import React, { use, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuBar from './common/MenuBar';
import '../assets/css/home.css';
import { unlockRXDetails, validateOrder, editOrderDetails, loadRxDetails, savePrescription,
  fetchAvailityMemberCoverage, loadAccumulator, getAttachmentPath, trackFedexShipment, 
  loadRXCostshareDetails, loadRebateValidationFlag, loadMemberConcern, getWinCardUrl
  ,getOpenOrdersFile
 } from '../Services/loadOrder';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast';
import { DataGrid } from '@mui/x-data-grid';
import '../assets/css/home.css';
import NeedsTrackingModal from './common/NeedsTrackingModal';
import OrderSummary from './common/OrderSummary';
import BackWindowModal from './common/BackWindowModal';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const NeedsOpenOrders = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  console.log("NeedsOpenOrders received state:", state);
  const { taskId, contract, pharmacyId, userId } = state || {};
  const [rxData, setRxData] = useState(null);
  const [error, setError] = useState(null);
  const [trackingNumber, setTrackingNumber] = useState('');
   const [trackingResult, setTrackingResult] = useState(null);
  const [shippingCarrier, setShippingCarrier] = useState('');
  const [gridRows, setGridRows] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
const [modalMessage, setModalMessage] = useState('');
const [shouldRedirect, setShouldRedirect] = useState(false);
const [showSummary, setShowSummary] = useState(false);
const [totalAmount, setTotalAmount] = useState('0.00');
const [pendingRollbackInfo, setPendingRollbackInfo] = useState(null);
const [isSubmitting, setIsSubmitting] = useState(false);
const [isBackWindowOpen, setIsBackWindowOpen] = useState(false);
const [pharmReimbWithoutRebate, setPharmReimbWithoutReabtae] = useState(0);
  const [pharmReimbwithRebate, setPharmReimbwithRebate] = useState(0);
  const [chewyRows, setChewyRows] = useState([]);
  const [chewyFertilityRows, setChewyFertilityRows] = useState([]);
  const [documents, setDocuments] = useState([]);
   // Add state for attachment URLs
  const [attachmentUrls, setAttachmentUrls] = useState([]);
  const [notesBoxActive, setNotesBoxActive] = useState(false);
  const [actualDeliveryDate, setActualDeliveryDate] = useState('');
  const [latestStatus, setLatestStatus] = useState('');
  const [errorTrackingStatus, setErrorTrackingStatus] = useState('');
  const [totalMemberPays, setTotalMemberPays] = useState('0.00');
  const [totalMenopurCostShare, setTotalMenopurCostShare] = useState('0.00');
  const [totalCopay, setTotalCopay] = useState('0.00');
  const [winCardAmount, setWinCardAmount] = useState('0.00');
  const [totalWinPays, setTotalWinPays] = useState('0.00');
  const [rebateValidationFlag, setRebateValidationFlag] = useState(null);
  const [mainGridRows, setMainGridRows] = useState([]);
  const [menopurGridRows, setMenopurGridRows] = useState([]);
  const [memberConcernFlag, setMemberConcernFlag] = useState(false);
  const [showMemberWinCard, setShowMemberWinCard] = useState(false);
  const [firstName, setFirstNAme] = useState('');
  const [lastName, setLastName] = useState('');
  const [totalCostShare, setTotalCostShare] = useState('0.00');
  const [requestId, setRequestId] = useState(''); 

  // for chewy contracts
  
  useEffect(() => {
    if (contract !== 'Chewy-Aetna-Premier' || !rxData) return;
  
    const fetchChewyGridsData = async () => {
      let memberId = rxData[0]?.MemberID;
      let patientFirstName = rxData[0]?.MemberName;
      let patientLastName = rxData[1]?.MemberName;
      let patientBirthDate = rxData[0]?.DOB;
      let sourceSystem = "PBMS";
      let user = userId;
      console.log("Fetching Chewy grids data with:", {
        memberId, 
        patientFirstName,
        patientLastName,
        patientBirthDate,
        contract,
        sourceSystem,
        user
      });
  
      if (
        memberId?.toLowerCase().includes("test") &&
        patientFirstName?.toLowerCase().includes("test") &&
        patientLastName?.toLowerCase().includes("test")
      ) {
        memberId = "234651_10";
        patientFirstName = "Lea";
        patientLastName = "Spencer";
        patientBirthDate = "10/08/1987";
        sourceSystem = "PBMS Test";
        user = "SADV";
      }
  
      const availityData = await fetchAvailityMemberCoverage({
        memberId,
        patientFirstName,
        patientLastName,
        patientBirthDate,
        contract,
        sourceSystem,
        user
      });
  
      // ---- Parse availityData to extract accumulator values ----
      let deductibleTotal = "0.00";
      let deductibleRemaining = "0.00";
      let coinsurancePercent = "0";
      let copayAmount = "0.00";
  
      try {
        const plans = availityData?.plans;
        if (plans && Array.isArray(plans)) {
          // Find the first plan with benefits
          const benefits = plans[0]?.benefits;
          if (benefits && Array.isArray(benefits)) {
            // Deductibles
            const amounts = benefits[0]?.amounts;
            const deductibles = amounts?.deductibles?.inNetwork || [];
            // Prefer "Individual", else "Family"
            const indDed = deductibles.find(x => x?.level === "Individual");
            const famDed = deductibles.find(x => x?.level === "Family");
            if (indDed) {
              deductibleTotal = indDed?.total?.toString() ?? "0.00";
              deductibleRemaining = indDed?.remaining?.toString() ?? "0.00";
            } else if (famDed) {
              deductibleTotal = famDed?.total?.toString() ?? "0.00";
              deductibleRemaining = famDed?.remaining?.toString() ?? "0.00";
            }
  
            // Coinsurance and Copay (from Infertility benefit, usually index 1)
            let planName = availityData?.planName || ""; // You may need to get this from somewhere else
            let coinsurance = 0;
            let copay = 0;
            if (benefits.length > 1) {
              // Try to get from Infertility benefit
              const infertilityAmounts = benefits[1]?.amounts;
              // Coinsurance
              const coins = infertilityAmounts?.coInsurance?.inNetwork?.[0]?.amount;
              coinsurance = coins ? parseFloat(coins) * 100 : 0;
              // Copay
              const copayVal = infertilityAmounts?.coPayment?.inNetwork?.[0]?.amount;
              copay = copayVal ? parseFloat(copayVal) : 0;
            }
            // If not found, fallback to plan type
            if (!coinsurance && planName.includes("PPO")) {
              coinsurance = 20;
              copay = 50;
            } else if (!coinsurance) {
              coinsurance = 10;
              copay = 0;
            }
            coinsurancePercent = coinsurance.toString();
            copayAmount = copay.toFixed(2);
          }
        }
      } catch (err) {
        console.error("Error parsing availityData:", err);
        toast.error("Failed to parse member coverage data");
      }
  
      // ---- Build DataGrid rows ----
      setChewyRows([
        {
          id: 1,
          'Member Cost Share': 'Deductible Total',
          'In-Network': `$ ${deductibleTotal}`,
          'Out-of-Network': 'NA'
        },
        {
          id: 2,
          'Member Cost Share': 'Deductible Remaining',
          'In-Network': `$ ${deductibleRemaining}`,
          'Out-of-Network': 'NA'
        },
        {
          id: 3,
          'Member Cost Share': 'Coinsurance',
          'In-Network': `${coinsurancePercent} %`,
          'Out-of-Network': 'NA'
        },
        {
          id: 4,
          'Member Cost Share': 'Copay',
          'In-Network': `$ ${copayAmount}`,
          'Out-of-Network': 'NA'
        }
      ]);
    };
  
    fetchChewyGridsData();
  }, [contract, rxData, userId]);
  
  const chewyColumns = [
    { field: 'Member Cost Share', headerName: 'Member Cost Share', width: 200, headerClassName: 'pink-header' },
    { field: 'In-Network', headerName: 'In-Network', width: 150, headerClassName: 'pink-header' },
    { field: 'Out-of-Network', headerName: 'Out-of-Network', width: 150, headerClassName: 'pink-header' }
  ];
  
  
  const chewyColumnsFertilityGrid = [
    { field: 'Fertility Accumulator', headerName: 'Fertility Accumulator', width: 200, headerClassName: 'pink-header' },
    { field: 'In-Network', headerName: 'In-Network', width: 150, headerClassName: 'pink-header' },
    { field: 'Out-of-Network', headerName: 'Out-of-Network', width: 150, headerClassName: 'pink-header' }
  ];
  useEffect(() => {
    if (contract !== 'Chewy-Aetna-Premier' || !rxData) return;
  
    const fetchChewyAccumulator = async () => {
      try {
        const result = await loadAccumulator(rxData[0]?.MemberID, rxData[0]?.AuthNo, contract);
        console.log("Accumulator Payload:", {
          MemberID: rxData[0]?.MemberID,
          AuthNo: rxData[0]?.AuthNo,
          Contract: contract
        });
        console.log("Accumulator Data:", result);
  
        if (result.success && result.data) {
          setChewyFertilityRows([
            {
              id: 1,
              'Fertility Accumulator': 'Benefit Limit',
              'In-Network': `$ ${result.data.AllowedAccumulator ?? '0.00'}`,
              'Out-of-Network': 'NA'
            },
            {
              id: 2,
              'Fertility Accumulator': 'Remaining Balance',
              'In-Network': `$ ${result.data.RemainingAccumulator ?? '0.00'}`,
              'Out-of-Network': 'NA'
            }
          ]);
        } else {
          setChewyFertilityRows([]);
          toast.error(result.message || "No accumulator data found.");
        }
      } catch (error) {
        console.error("Error fetching accumulator data:", error);
        toast.error("Failed to fetch accumulator data");
        setChewyFertilityRows([]);
      }
    };
  
    fetchChewyAccumulator();
  }, [contract, rxData]);



const handleRollback = async () => {
  // if (!trackingNumber?.trim() || !shippingCarrier?.trim()) {
  //   toast.error("Tracking Number and Shipping Carrier are required.");
  //   return;
  // }

  try {
    const result = await validateOrder({ contract, pharmacyId, taskId });

    const allowRollback = result?.ReturnValue == null;

    setModalMessage(
      allowRollback
        ? "The claim will be rolled back to Process Prescription."
        : "This claim order is under process. You cannot rollback the order."
    );

    setShouldRedirect(allowRollback); // used in onConfirm
    setPendingRollbackInfo({ contract, pharmacyId, taskId, userId });
    setModalOpen(true);
  } catch (err) {
    console.error("Rollback Error:", err);
    toast.error("An error occurred while processing rollback.");
    navigate('/error-page');
  }
};

const handleModalConfirm = async () => {
  setModalOpen(false);

  if (!shouldRedirect || !pendingRollbackInfo) return;

  const { contract, taskId, pharmacyId, userId } = pendingRollbackInfo;

  try {
    setIsSubmitting(true);

    // const contract = rxData?.Contract || rxData?.TaskDetail?.Contract;
     const memberID = rxData?.MemberID || rxData?.TaskDetail?.MemberID || rxData[0]?.MemberID || rxData[0]?.MemberID;
    const authNo = rxData?.AuthNo || rxData?.TaskDetail?.AuthNo || rxData[0]?.AuthNo || rxData[0]?.TaskDetail?.AuthNo;
  

    console.log(`dispQty: ${rxData?.Prescriptions?.[0]?.['Disp Qty'] || rxData?.Prescriptions?.[0]?.DispQty}`);
  
    if (!contract || !taskId || !memberID) {
      toast.error("Missing required prescription data. Cannot proceed.");
      navigate('/error-page');
      return;
    }
  
    setIsSubmitting(true);

      for (const row of gridRows) {
        const drugPayload = {
          Loop: 1,
          Flag: "Rollback",
          Contract: contract,
          PharmacyID: pharmacyId,
          TaskID: taskId,
          LineID: row?.PresID?.toString() || "", 
          NDC: row?.NDC,
          DispQty:  row?.['Disp Qty'] || row?.DispQty,
          Copay: 0,
          Amount: parseFloat(row?.Amount || 0),
          TaskType: "NT",
          UserID: userId,
          ScheduleStartDate: rxData?.SchStartDate || rxData?.TaskDetail?.SchStartDate || rxData[0]?.SchStartDate || rxData[0]?.TaskDetail?.SchStartDate,
          ScheduleEndDate: rxData?.SchEndDate || rxData?.TaskDetail?.SchEndDate || rxData[0]?.SchEndDate || rxData[0]?.TaskDetail?.SchEndDate,
          Message: "",
          MemberID: memberID,
          AuthNo: authNo,
          TotCoPay: 0,
          TotAmount: parseFloat(totalAmount),
          PriorityID: rxData?.PriorityID || rxData?.TaskDetail?.PriorityID || rxData[0]?.PriorityID || rxData[0]?.TaskDetail?.PriorityID,
          ShippingCarrier: shippingCarrier || "",
          TrackingNo: trackingNumber || "",
          Notes: rxData?.notes || "",
          Reason: row?.Reason || "",
        //   RebateAmount: 0,
          WithWinMarginWithoutRebate: 0,
          WintoPharmAmt: parseFloat(row?.Amount || 0) - 0
        };
        await savePrescription(drugPayload);
      }
  
      // Submit task-level summary (Loop = 0)
      const taskPayload = {
        Loop: 0,
        Flag: "Rollback",
        Contract: contract,
        PharmacyID: pharmacyId,
        TaskID: taskId,
        LineID: "",
        NDC: "",
        DispQty: 0,
        Copay: 0,
        Amount: parseFloat(totalAmount) || 0, // Ensure totalAmount is a number
        TaskType: "NT",
        UserID: userId,
        ScheduleStartDate: rxData?.SchStartDate || rxData?.TaskDetail?.SchStartDate || rxData[0]?.SchStartDate || rxData[0]?.TaskDetail?.SchStartDate,
        ScheduleEndDate: rxData?.SchEndDate || rxData?.TaskDetail?.SchEndDate || rxData[0]?.SchEndDate || rxData[0]?.TaskDetail?.SchEndDate,
        Message: "",
        MemberID: memberID,
        AuthNo: authNo,
        TotCoPay: 0,
        TotAmount: parseFloat(totalAmount),
          PriorityID: rxData?.PriorityID || rxData?.TaskDetail?.PriorityID || rxData[0]?.PriorityID || rxData[0]?.TaskDetail?.PriorityID,
        ShippingCarrier: shippingCarrier || "",
        TrackingNo: trackingNumber || "",
        Notes: rxData?.notes || "",
        Reason: "", // No reason for task-level
        // RebateAmount: 0,
        WithWinMarginWithoutRebate: 0, 
        WintoPharmAmt: 0
      };
      
        // Log the task-level payload for debugging
        

      console.log("Saving task-level payload:", taskPayload);
      await savePrescription(taskPayload);
    
  
      toast.success("Prescription submitted successfully!");
      const result = await unlockRXDetails (taskPayload.Contract, taskPayload.UserID, taskPayload.TaskID
        , taskPayload.PharmacyID);


        navigate('/process-prescription');

    await unlockRXDetails(contract, userId, taskId, pharmacyId);

    navigate('/process-prescription', {
      state: {
        taskId,
        contract,
        pharmacyId,
        userId,
        fromRollback: true
      }
    });
  } catch (err) {
    console.error("Rollback unlock failed:", err);
    toast.error("Unlock failed during rollback.");
    navigate('/error-page');
  }
};




//   const {
//   taskId,
//   contract,
//   pharmacyId,
//   userId,
//   shippingCarrier: passedCarrier,
//   trackingNumber: passedTracking,
//   rxData: passedRxData
// } = state || {};

  const handleBack = async () => {
    try{
      setIsBackWindowOpen(true);

    }catch (err) {
      console.error("Error in handleBack:", err);
      toast.error("An error occurred while navigating back.");
      navigate('/error-page');
    }
  }

const confirmBack = async () => {
  try {
    // const clearedRows = ([]).map(row => ({
    //   ...row,
    //   Reason: '',
    //   DispQty: 0,
    //   CancelQty: 0,
    //   Amount: 0
    // }));

    // await editOrderDetails({
    //   rxData,
    //   gridRows: clearedRows,
    //   userId,
    //   taskId,
    //   contract,
    //   vendorAuth:""
    // });

    toast.success("Order details cleared successfully.");

    await unlockRXDetails(contract, userId, taskId, pharmacyId);

    toast.success("Task unlocked successfully.");

    navigate('/needs-tracking', {
      state: {
        taskId,
        contract,
        pharmacyId,
        userId,
        fromRollback: true
      }
    });
  } catch (err) {
    console.error("Error in handleBack:", err);
    toast.error("An error occurred while navigating back.");
    navigate('/error-page');
  }
};

useEffect(() => {
  const fetchRxDetails = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || !taskId || !contract) return;

    try {
      const response = await loadRxDetails(taskId, contract, pharmacyId, userId);
      console.log("Response from loadRxDetails:", response);

      if (response.success) {
        // Prefer TaskDetail[0] if TaskDetail is an array, else use TaskDetail as object
        // const taskDetail = Array.isArray(response.data.TaskDetail)
        //   ? response.data.TaskDetail[0] || {}
        //   : response.data.TaskDetail || {};

        // const details = {
        //   ...taskDetail,
        //   DrugInfos: response.data.DrugInfos,
        //   Prescriptions: response.data.Prescriptions,
        //   ShippingInfos: response.data.ShippingInfos
        // };


        


        const { TaskDetail, DrugInfos, Prescriptions, ShippingInfos, Documents } = response.data;

        const details = {
          ...TaskDetail,
          DrugInfos,
          Prescriptions,
          ShippingInfos,
          Documents,
        };
        setRxData(details);
        const memberName = details[0]?.MemberName || '';
        console.log("Member Name:", memberName);
        const firstName = memberName.split(',')[1] || '';
        const lastName = memberName.split(',')[0] || '';
        setFirstNAme(firstName);
        setLastName(lastName);

        let memberConcern;
        if (details[0]?.ContractType === 'Premier' || contract === "Moelis-Cigna-Premier Rx") {
        memberConcern = await loadMemberConcern(taskId, contract);
        console.log("Member Concern Data:", memberConcern);
        if (memberConcern.data) {
          if (memberConcern.data.Flag === 'Y') {
            setMemberConcernFlag(true);
          }
          if (memberConcern.data.MemberConsent === 'Y') {
            setShowMemberWinCard(true);
          }
          setRequestId(memberConcern?.data?.RequestId);
        console.log("Request ID^^^^^^^^^^^^^^^^^:", memberConcern?.data?.RequestId);
        setTotalMenopurCostShare(memberConcern?.data?.MenopurCostshare || '0.00');
        }
      }

        if ((memberConcern && memberConcern.data.Flag === 'Y') && (details[0]?.ContractType === 'Premier' 
          || contract === "Moelis-Cigna-Premier Rx"
        )) {

           const rebateFlag = await loadRebateValidationFlag( contract,
                    details[0]?.MemberID, pharmacyId, userId );
                  setRebateValidationFlag(rebateFlag?.Validation === 'Y' ? 'Y' : 'N');
          
                  // Use details.Prescriptions for initial grid setup
            const prescriptions = details?.Prescriptions || [];
            const contractType = details[0]?.ContractType;
            const pharmacyID = details[0]?.PharmacyID || pharmacyId;
          
            console.log("Contract Type:", contractType);
          
            // Split prescriptions into Menopur and others
            const menopurRows = prescriptions.filter(p => p.DrugName?.toUpperCase().includes('MENOPUR'));
            const otherRows = prescriptions.filter(p => !p.DrugName?.toUpperCase().includes('MENOPUR'));
          
            console.log("Menopur Rows:", menopurRows);
            console.log("Other Rows:", otherRows);
          
            setMenopurGridRows(menopurRows.map(pres => ({
              ...pres,
              id: pres.PresID,
              CancelQty: parseFloat(pres.AppQty || 0) - parseFloat(pres.DispQty || 0)
            })));
          
            setMainGridRows(otherRows.map(pres => ({
              ...pres,
              id: pres.PresID,
              CancelQty: parseFloat(pres.AppQty || 0) - parseFloat(pres.DispQty || 0)
            })));
          
            // after setMenopurGridRows(...) and setMainGridRows(...)
          setGridRows([
            ...menopurRows.map(pres => ({ ...pres, id: pres.PresID, CancelQty: parseFloat(pres.AppQty||0)-parseFloat(pres.DispQty||0) })),
            ...otherRows.map(pres   => ({ ...pres, id: pres.PresID, CancelQty: parseFloat(pres.AppQty||0)-parseFloat(pres.DispQty||0) })),
          ]);
          setDocuments(Documents || []);
        //   const costShareValue = details?.Prescriptions[0]?.CostShare || '0.00';
        // console.log("Cost Share Value:+++++++++++++++++>", costShareValue);

        // setTotalCostShare(costShareValue);
          
          
          return; // keep your early return
          
        }

        const rebateFlag = await loadRebateValidationFlag( contract,
                  details[0]?.MemberID, pharmacyId, userId );
                setRebateValidationFlag(rebateFlag?.Validation === 'Y' ? 'Y' : 'N');

        console.log("Parsed RX Details:", details);

        const fetchUrls = async () => {
              const urls = await Promise.all(
                Documents.map(doc => getAttachmentPath(doc.Path))
              );
              console.log("Fetched attachment URLs:", urls);
              setAttachmentUrls(urls);}
              fetchUrls();

        const prescriptionsWithId = (Prescriptions || []).map(p => ({
          ...p,
          id: p.PresID, // ✅ ensure 'id' exists for DataGrid
          ['Reimbursement Amount']: parseFloat(p['Reimbursment Amount']).toFixed(2), // Format to 2 decimal places  ,
        }));

        console.log("Prescriptions with IDs:", prescriptionsWithId);
        const costShareValue = details?.Prescriptions[0]?.CostShare || '0.00';
        console.log("Cost Share Value:+++++++++++++++++>", costShareValue);

        setTotalCostShare(costShareValue);

        
        setShippingCarrier(details.ShippingInfos?.[0]?.ShippingCarrier || '');
        setGridRows(prescriptionsWithId); // ✅ FIXED
        setDocuments(Documents || []); // Set documents if available
      } else {
        setError(response.message);
      }
    } catch (err) {
      console.error("Error fetching RX details:", err);
      setError("Failed to load RX details.");
      navigate('/error-page');
    }
  };

  fetchRxDetails();
}, [taskId, contract, pharmacyId, userId]);


// Debounced tracking number validation
 useEffect(() => {
  if (!trackingNumber) {
    setTrackingResult(null);
    return;
  }
  if (shippingCarrier.toLowerCase() !== 'fedex') {
    //toast.error("Only FedEx tracking is supported.");
    return;
  }
  const handler = setTimeout(async () => {
    try {
      const response = await trackFedexShipment(trackingNumber);
      console.log("FedEx Tracking Response:$$$$$$$$>>>>>>>>", response);
      setTrackingResult(response);
      console.log ("this is the tracking result", response.data);
      const deliveryDate = response.data?.output?.completeTrackResults[0]?.
      trackResults[0]?.dateAndTimes?.find(
  item => item.type === "ACTUAL_DELIVERY"
)?.dateTime || "";

      const status = response.data?.output?.completeTrackResults[0]?.
      trackResults[0]?.latestStatusDetail?.statusByLocale;

      const errorStatus =  response.data?.output?.completeTrackResults[0]?.
      trackResults[0]?.error;

      if (errorStatus) {
        setErrorTrackingStatus(errorStatus);
        return;
      }

const onlyDate = deliveryDate.split("T")[0]; 
console.log(onlyDate);
      console.log("Latest Status and date",status, onlyDate);

      setActualDeliveryDate(onlyDate);
      setLatestStatus(status);
    } catch (error) {
      setTrackingResult(null);
      toast.error("Tracking failed. Please check the tracking number.");
    }
  }, 2000);

  return () => clearTimeout(handler);
}, [trackingNumber]);

useEffect(() => {
  if (!gridRows || (!mainGridRows && !menopurGridRows)) return;

  const fetchCostShare = async () => {

    let rxCost;
    let totalcostShare;
    let copay;
    let reimbAmountMain;
    let reimbAmountMenopur;
    let memberPaysMenopur;
    let memberPaysMain;
    let winCardAmount;

    // if( rebateValidationFlag === 'Y'){
    //   copay = parseFloat(rxData?.Prescriptions?.[0]?.Rx_Cost_Before_CostShareAMT);
      
    // } else if (rebateValidationFlag === 'N') {
   
    // copay = parseFloat(totalWinPaysBase);
    // }
    
    // const offerAmount = await calculateCostShareDetails(copay);

    if (memberConcernFlag === true) {
      reimbAmountMain = mainGridRows.reduce((sum, row) => sum + (parseFloat(row['Reimbursment Amount'] || 0)), 0);
      reimbAmountMenopur = menopurGridRows.reduce((sum, row) => sum + (parseFloat(row['Reimbursment Amount'] || 0)), 0);
      const copayMenopur = menopurGridRows.reduce((sum, row) => sum + (parseFloat(row['Member Pays']  || 0)), 0);
      const copayMain = mainGridRows.reduce((sum, row) => sum + (parseFloat(row['Member Pays']  || 0)), 0);
      const totalcopay = copayMenopur + copayMain;
      memberPaysMenopur = totalMenopurCostShare;
      memberPaysMain = Number(rxData?.Prescriptions[0]?.CostShare) - Number(memberPaysMenopur);
      winCardAmount = reimbAmountMenopur - memberPaysMenopur;
      copay = parseFloat(memberPaysMain + memberPaysMenopur).toFixed(2);
      rxCost = parseFloat(reimbAmountMain + reimbAmountMenopur).toFixed(2);
      totalcostShare = Number(memberPaysMenopur) + Number(memberPaysMain);
      //(rxCost - menopurTotal - totalCostShare) + menopurCostShare
      console.log("This is the copay: =====>", copay);
      console.log("This is the reimbusrement Amount: =====>", reimbAmountMain + reimbAmountMenopur);
      console.log("This is the winCardAmount: =====>", winCardAmount);
      console.log("This is the rxCost: =====>", rxCost);
      console.log("This is the reimbAmountMenopur: =====>", reimbAmountMenopur);
      console.log("This is the totalCostShare: =====>", totalcostShare);
      console.log("This is the memberPaysMenopur: =====>", memberPaysMenopur);
      console.log("This is totalcopay: =====>", totalcopay);
      setTotalCopay(totalcopay || '0.00');
      setTotalMemberPays(totalcostShare || '0.00');
      setTotalCostShare(totalcostShare || '0.00');
      setTotalWinPays( (((Number(rxCost) - Number(reimbAmountMenopur)) - Number(totalcostShare) )+ Number(memberPaysMenopur)) || '0.00');
      setWinCardAmount(winCardAmount.toFixed(2) || '0.00');
      

    } else {
      copay = gridRows.reduce((sum, row) => sum + (parseFloat(row['Member Pays']  || 0)), 0);
      reimbAmountMain = gridRows.reduce((sum, row) => sum + (parseFloat(row['Reimbursment Amount'] || 0)), 0);
      setTotalCopay(copay.toFixed(2) || '0.00');
      
      console.log("This is the copay: =====>", copay);
      console.log("This is the reimbusrement Amount: =====>", reimbAmountMain);
      setTotalMemberPays(totalCostShare || '0.00');
      setTotalWinPays(parseFloat(reimbAmountMain - totalCostShare).toFixed(2) || '0.00');
    }

    //setTotalMemberPays(offerAmount || '0.00');

  };
  fetchCostShare();
}, [rxData, gridRows]);


const calculateDrugCount = (prescriptions) => {
  let count = 0;

  prescriptions.forEach((item) => {
    const drugName = item.DrugName?.toUpperCase() || '';
    const appQty = parseFloat(item.AppQty || 0);
    const amount = parseFloat(item['Reimbursment Amount'] || 0);

    const isExcludedDrug =
      drugName === 'OTHER SUPPLIES' ||
      drugName === 'OTHER DRUGS';

    const isCommonForm =
      drugName.includes('SYRINGE') ||
      drugName.includes('NEEDLE') ||
      drugName.includes('PEN') ||
      drugName.includes('VIAL') ||
      drugName.includes('TAB') ||
      drugName.includes('SOFTGELS');

    if (
      appQty > 0 &&
      !isExcludedDrug &&
      (!isCommonForm || amount !== 0)
    ) {
      count++;
    }
  });
  console.log("This is the Calculated Drug Count:", count);
  return count;
};

// calculate the costshare details
const calculateCostShareDetails = async (copay) => {
  
  try {
    const firstTaskDetail = rxData?.[0] || (Array.isArray(rxData?.TaskDetail) ? rxData.TaskDetail[0] : undefined) || {};
const memberID = rxData?.MemberID || firstTaskDetail.MemberID || '';
  const authNo = rxData?.AuthNo || firstTaskDetail.AuthNo || '';
const priorityID = rxData?.PriorityID || firstTaskDetail.PriorityID || '';
const schStartDate = rxData?.SchStartDate || firstTaskDetail.SchStartDate || '';
const schEndDate = rxData?.SchEndDate || firstTaskDetail.SchEndDate || '';
const rxDataPrescriptions = rxData?.Prescriptions || [];

const drugCount = calculateDrugCount(rxDataPrescriptions);
console.log("This is the Drug Count:", drugCount);

console.log("prescription for cost share calculation:", rxDataPrescriptions);

console.log(`Member ID:, ${memberID} Auth No: ${authNo} priorityID: ${priorityID} schStartDate: ${schStartDate} schEndDate: ${schEndDate}`);

const value = await loadRXCostshareDetails(contract,memberID, userId, authNo, 
      copay, taskId, 'N',  drugCount
      );

      let result;

// Safely access the response data
if (value.success && Array.isArray(value?.data?.Detail)) {
  for (const item of value?.data?.Detail) {
    if (item.var_name === "memb_cost_share") {
      result = item;
      break;
    }
  }
} else {
  console.error("Unexpected data format or failed response:", value);
}

      console.log("needed result", result?.DeductionValue); 
      const offerAmount = result?.DeductionValue || '0.00';
      console.log("Offer Amount:", offerAmount); 

    //setSingleRowOfferAmount(result?.DeductionValue || '0.00');
    
    console.log(`Calculated Copay:  ${copay}`);

   {/* and Total Amount: ${totalAmount}*/}
   return offerAmount;

  }catch (error) { 
    console.error("Error calculating cost share details:", error);
    toast.error('Failed to calculate cost share details');
  };
}



  
  const handleSubmit = async () =>{
    try {
      if (!trackingNumber?.trim() || !shippingCarrier?.trim()) {
    toast.error("Missing Data - Please enter both the tracking # and Shipping Carrier in order to proceed.");
    return;
  }
  console.log("This is Grid Rows:", gridRows);
    await editOrderDetails({rxData: { TaskDetail: rxData },
                gridRows,
                 userId, taskId, contract, 
    });
    
    toast.success("Order details edited successfully.");
    setShowSummary(true);
    toast.success("Order summary.");
    } catch (error) {
      console.error("Error editing order details:", error);
      toast.error("Failed to edit order details.");
      navigate('/error-page');
      return;
    }
}

// // Calculate member pays for each prescription row
// const getMemberPaysArray = (Prescriptions) => {
//   if (!Array.isArray(Prescriptions)) return [];
//   // Replace 'MemberPays' with the actual property name for member's cost share in your data
//   return Prescriptions.map(row => parseFloat(row.MemberPays || row.DeductionAmount || 0));
// };

// // Calculate total member pays
// const getTotalMemberPays = (Prescriptions) => {
//   return getMemberPaysArray(Prescriptions).reduce((sum, val) => sum + val, 0).toFixed(2);
// };

// // Usage example:
// const memberPaysArray = getMemberPaysArray(rxData.Prescriptions || []);
// //const totalMemberPays = getTotalMemberPays(rxData.Prescriptions || []);

 const handleFileDisplay = async (file, bytes) => {
  if (!file) return;

  let fileName = typeof file === 'string' ? file : file.name;
  const ext = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
  const docType = 'Prescription';
  const memberID =rxData[0]?.MemberID;

  const base64 = bytes;

  
    try {
      const response = await getOpenOrdersFile(memberID, fileName, contract, docType, base64); // Pass null or omit base64
      if (response) {
        window.open(response, '_blank', 'noopener,noreferrer');
      }
    } catch (error) {
      console.error("Error fetching file:", error);
      toast.error('Failed to fetch file');
    }
    return ;
  
};



// calculate total amount for HMOI contracts

useEffect(() => {
  if ( (contract === 'Chewy-Aetna-Premier' && rxData?.Prescriptions)
  //|| (contract === "WINFertilityRx" && rxData?.Prescriptions) || (contract === 'WINFertility DTC' && rxData?.Prescriptions)
) {
    const total = rxData.Prescriptions.reduce(
      (sum, row) => sum + parseFloat(row?.['Reimbursment Amount'] || 0),
      0
    )
    setTotalWinPays(total.toFixed(2));

  } else if ((contract === 'HMO Illinois'|| contract === 'CIGNA' || contract === "WINFertilityRx" || contract === 'WINFertility DTC' ) && rxData?.Prescriptions){
    const total = rxData.Prescriptions.reduce(
      (sum, row) => sum + parseFloat(row?.['Reimbursment Amount'] || 0),
      0)
    setTotalAmount(total.toFixed(2));
    setTotalWinPays(total.toFixed(2));
  }
}, [contract, rxData]);


  const MemberPaysCalculated = (prescriptions = []) => {
  // Sum all Member Pays or DeductionAmount in the array
  const total = prescriptions.reduce(
    (sum, row) => sum + parseFloat(row?.['Member Pays'] || row?.DeductionAmount || 0),
    0
  );
  return total.toFixed(2);
};


//const totalMemberPays = MemberPaysCalculated(rxData?.Prescriptions || []);



  const TotalAmountCalculatedBase = (prescriptions = []) => {
    let total = 0;

    for (const row of prescriptions || []) {
      const winPays = parseFloat(row?.['Reimbursment Amount'] );
      total += isNaN(winPays) ? 0 : winPays;
    }
    return total.toFixed(2);
  }

  // if (rxData[0]?.ContractType?.trim() === 'Premier' && memberConcernFlag === false) {
  //   const totalWinPaysBase = TotalAmountCalculatedBase(rxData?.Prescriptions || []);
  //   s
  // }
  


   //toatal reimbursement amount
    const totalReimbursement = rxData?.Prescriptions.reduce((sum, row) => {
        return sum + parseFloat(row?.['Reimbursment Amount'] || 0);
      }, 0);

    const totalMainReimbAmount = mainGridRows.reduce((sum, row) => {
        return sum + parseFloat(row?.['Reimbursment Amount'] || 0);
      }, 0);

    const totalMenopurReimbAmount = menopurGridRows.reduce((sum, row) => {
        return sum + parseFloat(row?.['Reimbursment Amount'] || 0);
      }, 0);

      
  
    const totalValueForDeduction = rxData?.Prescriptions[0]?.Rx_Cost_Before_CostShareAMT;
  
   useEffect(() => {
  const safeReimb = parseFloat(totalReimbursement || 0).toFixed(2);
  const safeRebate = parseFloat(totalValueForDeduction || 0).toFixed(2);

  setPharmReimbWithoutReabtae(safeReimb);
  setPharmReimbwithRebate(safeRebate);

  console.log("values from pharmReimbWithoutReabtae:", safeReimb, "pharmReimbwithRebate:", safeRebate);
}, [totalReimbursement, totalValueForDeduction]);

let summaryRow = []; 
let summaryRowMainGrid = [];
   let summaryRowMenopurGrid = [];  
    
   if (error) {
  navigate('/error-page');
  return null;
}

  if (!rxData) {
    return (
    <div>
      <MenuBar />
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
        <CircularProgress sx={{ color: '#ec008c' }} />
        <span style={{ marginTop: '16px', color: '#ec008c', fontSize: '16px', fontWeight: 500 }}>
          Your request is being processed...
        </span>
      </Box>
    </div>
  );
  }

   if ((rxData[0]?.ContractType?.trim() === 'Premier' || contract === "Moelis-Cigna-Premier Rx" )&& memberConcernFlag === true) {
    summaryRowMainGrid = {
  id: 'summary-row',
  'Reimbursment Amount': Number(totalMainReimbAmount).toFixed(2),
};

summaryRowMenopurGrid = {
  id: 'summary-row',
  'Reimbursment Amount': Number(totalMenopurReimbAmount).toFixed(2),
};
   }else if (contract === 'HMO Illinois' || contract === 'CIGNA'){
    summaryRow = {
    id: 'summary-row',
  'Reimbursment Amount': totalAmount,
  // All other fields left blank
};
   }
   
   else {

summaryRow = {
  id: 'summary-row',
  'Reimbursment Amount': Number(totalReimbursement).toFixed(2),
  // All other fields left blank
};
}



  const rowsWithSummary = [...gridRows, summaryRow];
  const mainGridRowsWithSummary = [...mainGridRows, summaryRowMainGrid];
  const menopurGridRowsWithSummary = [...menopurGridRows, summaryRowMenopurGrid];


  

  console.log("trackingNumber:", trackingNumber, "shippingCarrier:", shippingCarrier);

  // extract Document Array
    const document = documents || [];
    console.log("Documents Array:", document);

    const documentArray = document.map((doc, index) => ({

      id: index,
      documentList: doc.Path,
      bytes: doc.PDFDocument,
    })
  
  )

  const documentArraylength = documentArray.length;

  console.log("Document Array:", {documentArray, documentArraylength});

  const columns = [
    { field: 'MedStartDate', headerName: 'Med Start Date',flex:1, headerClassName: 'pink-header', sortable: false, },
    { field: 'NDC', headerName: 'NDC', flex:1, headerClassName: 'pink-header', sortable: false, },
    { field: 'DrugName', headerName: 'Drug Name',flex:1.3, headerClassName: 'pink-header', sortable: false,  renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  ), },
    { field: 'GPIName', headerName: 'GPI Name',flex:1.2, headerClassName: 'pink-header', sortable: false,  renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  ), },
    { field: 'AppQty', headerName: 'App Qty',flex:.8, headerClassName: 'pink-header', sortable: false, },
    { field: 'Units', headerName: 'Units',flex:.8, headerClassName: 'pink-header', sortable: false, },
    { field: 'Disp Qty', headerName: 'Disp Qty',flex:.8, headerClassName: 'pink-header', sortable: false, },
    { field: 'Cancel Qty', headerName: 'Cancel Qty',flex:.8, headerClassName: 'pink-header', sortable: false, },
    { field: 'Reason', headerName: 'Reason',flex:1, headerClassName: 'pink-header', sortable: false, },
    //{ field: 'Reimbursement Amount', headerName: 'Amount', width: 100, headerClassName: 'pink-header' }
  ];{
    if((rxData?.ContractType && rxData.ContractType.trim() !== '' ) || ( rxData[0]?.ContractType && 
  rxData[0]?.ContractType.trim() !== '') || contract === 'Moelis-Cigna-Premier Rx') {
      columns.push({ field: 'Reimbursment Amount', headerName: 'Reimbursement Amount', width: 140, headerClassName: 'pink-header', sortable: false, });
    }else if(contract === 'HMO Illinois' || contract === 'CIGNA' || contract === "WINFertilityRx" || contract === 'WINFertility DTC'){
      columns.push({ field: 'Reimbursement Amount', headerName: 'Reimbursement Amount', width: 140, headerClassName: 'pink-header', sortable: false, });
  }
}

    const winCardCol = {
      field: 'WinCard',
      headerName: 'WinCard',
      width: 200,
      sortable: false,
      headerClassName: 'pink-header',
      renderCell: (params) => {
        if (!params.row.DrugName?.toUpperCase().includes('MENOPUR') || params.row.isSummary) return null;
    
        if (showMemberWinCard){
        return (
          <button
            style={{
              padding: '4px 12px',
              borderRadius: '8px',
              background: '#ec008c',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
              fontSize: '13px'
            }}
            onClick={async () => {
              const info = {
                PresID: params.row.PresID,
                MemberID: params.row.MemberID,
                external_requestor_id: requestId,
                // ...add other required fields if needed
              };
              const winCardLink = await getWinCardUrl(info);
             if (winCardLink) {
          // Replace the empty external_requestor_id in the URL with info.external_requestor_id
          const updatedLink = winCardLink.replace(
            /external_requestor_id=([^&]*)/,
            `external_requestor_id=${encodeURIComponent(info.external_requestor_id)}`
          );
          window.open(updatedLink, '_blank');
        } else {
          toast.error("Win Card link not available.");
        }
            }}
          >
            View WinCard
          </button>
        );
      } else if (!showMemberWinCard) {
        return (
          <span style={{ color: 'gray',  fontSize: '12px',
            wordBreak: 'break-word',
        overflowWrap: 'break-word', textAlign: 'center'
           }}>
            Call member to get card details
          </span>
        );
    
      }
      }
    }
    //  Menopur grid columns: start from main and then add WINCard when that scenario applies
    const showWinCard =
      (memberConcernFlag === true ) &&
      (rxData?.ContractType?.trim() === 'Premier' || rxData?.[0]?.ContractType?.trim() === 'Premier'
      || contract === "Moelis-Cigna-Premier Rx");
    
    const columnsMenopur = showWinCard ? [...columns, winCardCol] : columns;

        return (
          
            <>
            {!showSummary &&(
            <div>
            <Toaster position="top-right" />
                <MenuBar onNavigateAttempt={() => setIsBackWindowOpen(true)}/>
            <div className='top-page-option'>

            <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center' }}>
                <a 
                    href="#/needs-tracking" 
                    style={{
                    textDecoration: 'none',
                    color: '#ec088c',
                    display: 'inline-flex',
                    alignItems: 'center'
                    }}
                    onClick={async () => {
              try {
                const user = JSON.parse(localStorage.getItem('user'));
                const userId = user?.userId;
                const pharmacyId = user?.pharmacyId;
                if (!userId || !pharmacyId || !taskId || !contract) {
                  toast.error('Missing required data for unlocking.');
                  return;
                }
                const result = await unlockRXDetails(contract, userId, taskId, pharmacyId);
                
                if (result.success) {
                  toast.success('Task unlocked successfully');
                } else {
                  toast.error(result?.Message || 'Failed to unlock task');
                }
              } catch (err) {
                console.error('Unlock error:', err);
                toast.error('An error occurred while unlocking');
              }
            }}
                >
                    <ChevronLeft color='#ec088c' size={18} />
                    <span style={{ marginLeft: '5px' }}>Back</span>
                </a>
            </div>

             <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                      <span>New Orders</span>
                      <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px' }} />
                      <span>Needs Tracking</span>
                      <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px' }}/>
                      <span>Open Orders</span>
                    </div>
                     </div>

            <div className="outer-box" style={{
          background: '#fff',
          padding: '0px',
          borderRadius: '10px',
          marginLeft: '100px',
          marginRight: '100px',
          textAlign: 'left', // force left alignment for all children
          alignItems: 'flex-start', // ensure children align left
          display: 'block' // remove any flex centering
        }}> 
        <div className="open-order-box" style={{fontFamily: 'segoe ui', textAlign: 'left', alignItems: 'flex-start', display: 'block' }}>

        <div className="sub-section-header" style={{color: '#ec008c', fontWeight: 'bold', marginBottom: '-5px',marginLeft:'25px', fontSize: '18px' }}>Member Info</div>
<br style={{ display: 'none' }} />
<div className="details-grid" style={{
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '18px 32px',
  borderRadius: '10px',
  padding: '18px 24px',
  marginBottom: '-30px',
  alignItems: 'start',
  fontSize: '14px',
  color: '#222',
  fontFamily: 'segoe ui',
  textAlign: 'left',
  justifyItems: 'start',
  width: 'fit-content',
  marginLeft: 0
}}>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '145px', display: 'inline-block', flexShrink: 0 }}>Member ID:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{rxData[0]?.MemberID}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '145px', display: 'inline-block', flexShrink: 0 }}>First Name :</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{firstName}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '145px', display: 'inline-block', flexShrink: 0 }}>Last Name :</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{lastName}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>DOB:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-80px', wordBreak: 'break-all', flex: 1 }}>{new Date(rxData[0]?.DOB).toLocaleDateString()}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '175px', display: 'inline-block', flexShrink: 0 }}>Member Phone:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{rxData[0]?.CellPhone}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>Email ID:</strong>
    {rxData[0]?.EmailID && rxData[0]?.EmailID.length > 30 ? (
      <div style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', whiteSpace: 'pre-line', flex: 1 }}>{rxData[0]?.EmailID}</div>
    ) : (
      <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{rxData[0]?.EmailID}</span>
    )}
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '150px', display: 'inline-block', flexShrink: 0 }}>Relationship:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{rxData[0]?.RelationShip || 'N/A'}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '150px', display: 'inline-block', flexShrink: 0 }}>Certified for:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{rxData[0]?.CertifiedFor}</span>
  </div>
</div><br/>

<div style={{ margin: '20px 0', width: '100%', paddingLeft: '20px' }}>
  <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '14px', tableLayout: 'fixed', fontFamily: 'segoe ui' }}>
    <colgroup>
      <col style={{ width: '33.33%' }} />
      <col style={{ width: '33.33%' }} />
      <col style={{ width: '33.33%' }} />
    </colgroup>
    <thead>
      <tr>
        <th style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Provider Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Authorization Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Attachments</th>
      </tr>
    </thead>
    <tbody style={{ fontFamily: 'segoe ui' }}>
      <tr style={{ fontFamily: 'segoe ui', height: '38px' }}>
        <td style={{ borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui', fontFamily: 'segoe ui' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Name:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.SerProName}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Phone:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.Telephone}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Fax:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.Fax}</span>
          </div>
        </td>
        <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>WIN Auth #:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.FormattedAuthNo}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Auth Duration:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.["Auth Duration"]}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Contract:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{contract}</span>
          </div>
        </td>
        <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          {documentArray.length > 0 && (
  <div className="attachment-box" style={{ flex: "0 1 300px", textAlign: 'left', paddingTop: '-20px', fontFamily: 'segoe ui', marginTop: '-14px' }}>
    {documentArray.map((doc, index) => {
      const fileUrl = doc.documentList.replaceAll('\\', '/').replaceAll('\\\\', '/');
      const fileName = fileUrl.split('/').pop();
      // const downloadUrl = attachmentUrls[index]; // Not needed for handleFileDisplay
      return (
        <button
          key={doc.id}
          type="button"
          className="attachment-link"
          style={{
            color: 'blue',
            display: 'flex',
            alignItems: 'center',
            marginTop: '10px',
            fontFamily: 'segoe ui',
            fontSize: '14px',
            textDecoration: 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
          onClick={() => handleFileDisplay(doc.documentList, doc.bytes)}
        >
          <strong style={{ fontSize: '15px', fontFamily: 'segoe ui', marginRight: '4px', textDecoration: 'none' }}>{`Prescription ${index + 1}:`}</strong>
          <span style={{ fontSize: '14px', fontFamily: 'segoe ui', textDecoration: 'underline' }}>{fileName}</span>
        </button>
      );
    })}
  </div>
)}
        </td>
      </tr>
    </tbody>
  </table>
  {/* New 2-column table below the existing table, same design */}

 <table style={{ marginTop:'30px',borderCollapse: 'collapse', width: '100%', fontSize: '13px', tableLayout: 'fixed', fontFamily: 'segoe ui',padding: '0 5px' }}>
    <colgroup>
      <col style={{ width: '33.3%' }} />
      <col style={{ width: '66.7%' }} />
    </colgroup>
    <thead>
      <tr>
        <th style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '5px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Task Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Task Notes</th>
      </tr>
    </thead>
    <tbody style={{ fontFamily: 'segoe ui' }}>
      <tr style={{ fontFamily: 'segoe ui', height: '38px' }}>
        <td style={{ fontFamily: 'segoe ui' , padding: '6px', }}>
          
           <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Assigned by:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.AssignedBy}</span>
          </div>
           <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Group ID:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.GroupID}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Priority:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.PriorityStatus}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Received:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.ReceivedDate}</span>
          </div>
		   <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Med Start Date:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.SchStartDate}</span>
          </div>
         </td>
      <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "40px",
        maxWidth: "80%",
      }}
    >
      <div
        className="notes-box"
        style={{
          flex: "1 1 300px",
          position: 'relative',
          boxShadow: notesBoxActive ?  '#ec008c' : undefined,
          borderRadius: '8px',
          padding: '4px',
          transition: 'box-shadow 0.2s',
        }}
        onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
        tabIndex={0}
      >
        <textarea
          className="notes-textarea"
          readOnly
          value={rxData[0]?.Notes || ""}
          style={{
            width: "95%",
            minHeight: "100px",
            padding: "12px",
            fontSize: "13px",
            borderRadius: "25px",
            border: "1px solid rgba(236, 152, 202)",
            resize: "vertical",
            background: 'white',
            outline: 'none',
            color: notesBoxActive ? '#ec008c' : 'black',
            transition: 'color 0.2s',
          }}
          onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '1px 2px rgba(236, 152, 202)';
      }}
        />
      </div>
    </div>
        </td>
      </tr>
    </tbody>
  </table>

</div>
        
                </div>
               {(contract === "HMO Illinois" || contract === 'CIGNA' || (rxData?.ContractType && rxData.ContractType.trim() !== '') || (  rxData[0]?.ContractType &&
  rxData[0]?.ContractType.trim() !== '') || (contract === "Moelis-Cigna-Premier Rx") || (contract === "WINFertilityRx") || 
(contract === 'WINFertility DTC')) && (
                    <div className="open-order-box" style={{ fontFamily: 'segoe ui' }}>
                      <div className="sub-section-header" style={{color: '#ec008c', fontWeight: 'bold', fontSize: '18px' }}>Shipping Info</div><br/>
                      <table className='Shpping-Info-table' style={{ margin: '0 auto', width: '60%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
  <colgroup>
    <col style={{ width: '50%' }} />
    <col style={{ width: '50%' }} />
  </colgroup>
  <tbody>
    <tr>
      <td style={{ fontSize: '14px', textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>     
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Phone :</strong>
          <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData.ShippingInfos[0]?.Phone}</span>
        </div>  
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}
          
          >Shipping Carrier :</strong>
           <FormControl size="small" sx={{ minWidth: 100, height: '30px', background: '#fff', borderRadius: '4px', marginRight: '10px' }}>
  <InputLabel sx={{ fontFamily: 'segoe ui', marginBottom: '10px', background: '#fff', color: 'black', fontSize: '12px' }}>
    --Select--
  </InputLabel>
  <Select
    value={shippingCarrier}
            onChange={(e) => setShippingCarrier(e.target.value)}
    label="Select"
    sx={{
      fontFamily: 'segoe ui',
      fontSize: '12px',
      border: '1px solid rgba(236, 152, 202)',
      borderRadius: '10px',
      height: '30px',
      boxShadow: 'none',
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ec008c',
        boxShadow: '0 0 6px rgba(236, 0, 140, 0.4)',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ec008c',
      },
    }}
  >
    <MenuItem value="" sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#ec008c', color: 'white' } }}>
      --Select--
    </MenuItem>
    
      <MenuItem value="Fedex" sx={{ fontSize: '12px',  '&:hover': { backgroundColor: '#ec008c', color: 'white' } }}>
        FedEx
      </MenuItem>
      <MenuItem value="UPS" sx={{ fontSize: '12px',  '&:hover': { backgroundColor: '#ec008c', color: 'white' } }}>
        UPS
      </MenuItem>
      <MenuItem value="Others" sx={{ fontSize: '12px',  '&:hover': { backgroundColor: '#ec008c', color: 'white' } }}>
        Others
      </MenuItem>
    
  </Select>
</FormControl>
        </div>
      </td>
    </tr>
    <tr>
      <td style={{ textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>     
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Fax :</strong>
          <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData.ShippingInfos[0]?.Fax || '—'}</span>
        </div>
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>#Tracking :</strong>
          <input
            type="text"
            name="trackingID"
            autoComplete='off'
            value={trackingNumber}
            onChange={(e) => setTrackingNumber(e.target.value)}
            style={{
             width: '30%',
              height: '20px',
              minHeight: '20px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '15px',
              border: '1px solid rgba(236, 152, 202)',
              marginLeft: '8px',
              outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          />
        </div>
       {/* Show tracking result below input */}
         {trackingResult && (
  <div
    style={{
      color: trackingResult.success ? 'green' : 'red',
      marginTop: '6px',
      marginLeft: '10px',
    }}
  >
    {trackingResult.success === false && (
  <div style={{ color: 'red', textAlign: 'left' }}>
    We were unable to fetch tracking details at the moment.
    Please try again later.
  </div>
)}
    {trackingResult.success === true && !errorTrackingStatus ? (
  latestStatus === 'Delivered' ? (
    <>
      Success! <br />
      Your package was successfully {latestStatus} on {actualDeliveryDate}. <br />
    </>
  ) : (
     <>
      Success! <br />
      We have found your Shipment details. <br />
      Your package is Currently {latestStatus} and is scheduled for delivery on {actualDeliveryDate}. <br />
    </>
  )
) : null}
 
 {errorTrackingStatus &&
  <div style={{ color: 'red', textAlign: 'left' }}>
   We couldn't find any tracking information for the number provided.
    Please double check your tracking number and try again.
  </div>
 }
 
  </div>
)}
      </td>
    </tr>
    <tr>
      <td style={{ textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Address :</strong>
          <textarea value={rxData.ShippingInfos[0]?.Address || ''}
            readOnly
            style={{
              width: '80%',
              minHeight: '60px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '20px',
              border: '1px solid rgba(236, 152, 202)',
              resize: 'vertical',
              marginLeft: '8px',
              outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          ></textarea>
        </div>
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Notes :</strong>
          <textarea name="trackingID"
            style={{
              width: '500px',
              minHeight: '60px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '20px',
              border: '1px solid rgba(236, 152, 202)',
              resize: 'vertical',
              marginLeft: '8px',
              outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
            
            placeholder='Please enter the Notes'></textarea>
        </div>
      </td>
    </tr>
  </tbody>
</table>

</div>
                )}
                  <div className="sub-section-header" style={{ color: '#ec008c', fontWeight: 'bold', margin: '10px 14px',  fontSize: '18px', textAlign: 'left', padding: '10px' }}>Prescriptions</div>
                { (contract === "HMO Illinois" || contract === 'CIGNA') &&(
                <div className="sub-section-header" style={{ color: 'red', fontWeight: 'bold', margin: '10px 14px',  fontSize: '12px', textAlign: 'left', padding: '10px' }}>This order is for a WIN member where WIN will pay for the drugs directly. Bill WIN directly by submitting the tracking number for only those drugs where you are expecting payment from WIN. All other drugs should be marked as cancelled.</div>
                )}
                { (contract === "SchoolCare" || contract === "Gartner-Cigna" || contract === "Smith & Nephew" 
                // || contract === "Lurie Childrens Hospital-Aetna-Premier"  
                  
                 ) &&(
                <div className="sub-section-header" style={{ color: 'red', fontWeight: 'bold', margin: '10px 14px',  fontSize: '12px', textAlign: 'left', padding: '10px' }}>Members in this contract are under Cigna PBM. Please contact Cigna PBM if the necessary authorization number is missing.</div>
                )}
                
                <div style={{ height: 'auto', width: '100%' }}>
                 {( rxData[0]?.ContractType === 'Premier' || contract === "Moelis-Cigna-Premier Rx" ) && memberConcernFlag === true && (
                  <>
                  { (mainGridRows.length > 0) &&(
                    <DataGrid
                      rows={mainGridRowsWithSummary }
                      columns={columns}
                      pageSize={5}
                      rowsPerPageOptions={[5]}
                      hideFooter
                      getRowClassName={(params) =>
                        params.row.isSummary ? 'summary-row' : ''
                      }
                      sx={{
                            fontSize: '12px',
                            fontFamily: 'Segoe UI',
                            '& .pink-header': {
                              color: '#fff',
                              backgroundColor: '#ec008c',
                              fontWeight: 'bold',
                               whiteSpace: 'normal !important',
                  wordBreak: 'breakWord !important',
                  overflowWrap: 'breakWord !important',
                  lineHeight: '1.3 !important',
                  textAlign: 'center', /* Optional: center the header text */
                  padding: '8px 2px !important',
                            },
                             '& .MuiDataGrid-row:hover': {
                              backgroundColor: '#f5f5f5 !important',
                              cursor: 'pointer',
                            },// Remove blue outline on cell focus
                    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                      outline: 'none !important',
                      boxShadow: 'none !important',
                      backgroundColor: 'none !important',  
                     },
                     //'& .MuiDataGrid-row:focus-within': {
                    //   backgroundColor: '#f5bcbc !important',
                    // },
                    // Remove blue outline on column header focus
                    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                      outline: 'none !important',
                      boxShadow: 'none !important',
                    },
                          }}
                    /> )}
                    <DataGrid
                      rows={menopurGridRowsWithSummary }
                      columns={columnsMenopur}
                      pageSize={5}
                      rowsPerPageOptions={[5]}
                      hideFooter
                      getRowClassName={(params) =>
                        params.row.isSummary ? 'summary-row' : ''
                      }
                      sx={{
                            fontSize: '12px',
                            fontFamily: 'Segoe UI',
                            '& .pink-header': {
                              color: '#fff',
                              backgroundColor: '#ec008c',
                              fontWeight: 'bold',
                               whiteSpace: 'normal !important',
                  wordBreak: 'breakWord !important',
                  overflowWrap: 'breakWord !important',
                  lineHeight: '1.3 !important',
                  textAlign: 'center', /* Optional: center the header text */
                  padding: '8px 2px !important',
                            },
                             '& .MuiDataGrid-row:hover': {
                              backgroundColor: '#f5f5f5 !important',
                              cursor: 'pointer',
                            },// Remove blue outline on cell focus
                    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                      outline: 'none !important',
                      boxShadow: 'none !important',
                      backgroundColor: 'none !important',  
                     },
                     //'& .MuiDataGrid-row:focus-within': {
                    //   backgroundColor: '#f5bcbc !important',
                    // },
                    // Remove blue outline on column header focus
                    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                      outline: 'none !important',
                      boxShadow: 'none !important',
                    },
                          }}
                    />
                  </>
                )}
                                      { (memberConcernFlag === false &&(<DataGrid
                                        rows={rowsWithSummary}
                                        columns={columns}
                                        pageSize={5}
                                        rowsPerPageOptions={[5]}
                                        hideFooter
                                        getRowClassName={(params) =>
                                        params.row.isSummary ? 'summary-row' : ''}
                                        sx={{
                            fontSize: '12px',
                            fontFamily: 'Segoe UI',
                            '& .pink-header': {
                              color: '#fff',
                              backgroundColor: '#ec008c',
                              fontWeight: 'bold',
                               whiteSpace: 'normal !important',
                  wordBreak: 'breakWord !important',
                  overflowWrap: 'breakWord !important',
                  lineHeight: '1.3 !important',
                  textAlign: 'center', /* Optional: center the header text */
                  padding: '8px 2px !important',
                            },
                             '& .MuiDataGrid-row:hover': {
                              backgroundColor: '#f5f5f5 !important',
                              cursor: 'pointer',
                            },// Remove blue outline on cell focus
                    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                      outline: 'none !important',
                      boxShadow: 'none !important',
                      backgroundColor: 'none !important',  
                     },
                     //'& .MuiDataGrid-row:focus-within': {
                    //   backgroundColor: '#f5bcbc !important',
                    // },
                    // Remove blue outline on column header focus
                    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                      outline: 'none !important',
                      boxShadow: 'none !important',
                    },
                          }}
                                      />))}
            {/* {contract === 'Chewy-Aetna-Premier' && (
              <div style={{ display: 'flex', gap: '20px', margin: '20px' }}>
                <div style={{ flex: 1, minWidth: 400,   }}>
                  <DataGrid
                    rows={chewyFertilityRows}
                    columns={chewyColumnsFertilityGrid}
                    pageSize={4}
                    hideFooter
                    sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            '& .pink-header': {
              color: '#fff',
              backgroundColor: '#ec008c',
              fontWeight: 'bold',
               whiteSpace: 'normal !important',
  wordBreak: 'breakWord !important',
  overflowWrap: 'breakWord !important',
  lineHeight: '1.3 !important',
  textAlign: 'center',
  padding: '8px 2px !important',
            },
             '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5bcbc !important',
              cursor: 'pointer',
            },
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
      backgroundColor: 'none !important',  
     },
     
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
          }}
                  />
                </div>
                <div style={{ flex: 1, minWidth: 400 }}>
                  <DataGrid
                    rows={chewyRows}
                    columns={chewyColumns}
                    pageSize={4}
                    hideFooter
                    sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            '& .pink-header': {
              color: '#fff',
              backgroundColor: '#ec008c',
              fontWeight: 'bold',
               whiteSpace: 'normal !important',
  wordBreak: 'breakWord !important',
  overflowWrap: 'breakWord !important',
  lineHeight: '1.3 !important',
  textAlign: 'center', 
  padding: '8px 2px !important',
            },
             '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5bcbc !important',
              cursor: 'pointer',
            },
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
      backgroundColor: 'none !important',  
     },
     
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
          }}
                  />
                </div>
              </div>
            )} */}
            

           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '40px' }}>
  {(contract === 'HMO Illinois' || contract === 'CIGNA' || contract === 'WINFertilityRx' || contract === 'WINFertility DTC' ) && (
    <div style={{ color: '#000', marginBottom: '6px' }}>
      Total Amount: ${parseFloat(totalWinPays).toFixed(2)}
    </div>
  )}

  {((rxData?.ContractType?.trim() === 'Premier' || rxData[0]?.ContractType?.trim() === 'Premier' || contract === 'Moelis-Cigna-Premier Rx'
   )) && (
    <>
    
      <div style={{ color: '#000', marginBottom: '6px' }}>
        Member Cost Share: ${ parseFloat(totalCostShare).toFixed(2)}
      </div>
      
      <div style={{ color: '#000' }}>
        WIN To Pharmacy: ${parseFloat(Math.max(0, totalWinPays)).toFixed(2)}
      </div>
      {(memberConcernFlag) && 
    (
      <div style={{ color: '#000' }}>
        WIN CardValue: ${parseFloat(winCardAmount).toFixed(2)}
      </div>
    )}
    </>
   )} 
</div>
                    </div>

<div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginRight: '20px', gap: '0px' }}>
                   
{contract !== 'WINFertility DTC' &&
 contract !== 'WINFertilityRx' &&
 contract !== 'WINFertility Genetics' &&(
<button className="button-open-order" onClick={handleRollback}>
  RollBack
</button>)}



<button
    className="button-open-order"
    onClick={handleBack}
  >
    Back
  </button>

  
  <button className="button-open-order" onClick={handleSubmit}>Submit</button>
      </div>      
            </div>
           
            </div>

             )}

                    {showSummary && (
                    <OrderSummary
                      flag = {'Needs'}
                      rxData={rxData}
                      gridRows={gridRows}
                      menopurGridRows = {menopurGridRows}
                      maingridRows = {mainGridRows}
                      columns={columns}
                      totalAmount={totalAmount}
                      userId={userId}
                      shippingCarrier={shippingCarrier}
                      trackingNumber={trackingNumber}
                      notes={rxData[0]?.Notes || ""}
                      taskId={taskId}
                      pharmacyId={pharmacyId}
                      TotalMemberPays={ totalMemberPays}
                      TotalCopay={totalCopay}
                      TotalMenopurCostShare={totalMenopurCostShare}
                      TotalWinPays={totalWinPays}
                       PharmReimbWithoutRebate = {pharmReimbWithoutRebate}
                      PharmReimbWithRebate = {pharmReimbwithRebate}
                      Contract={contract}
                      totalWinCardAmount={winCardAmount}

                      onCancel={() => setShowSummary(false)}
                    />
                  )}



            <NeedsTrackingModal
              open={modalOpen}
              onClose={() => setModalOpen(false)}
              onConfirm={handleModalConfirm}
              confirmMessage={modalMessage}
            />
            {isBackWindowOpen&&<BackWindowModal
              open={isBackWindowOpen}
              onClose={() => setIsBackWindowOpen(false)}
              onConfirm={confirmBack}/>}

              
            </>
            

        );
      

      };
        export default NeedsOpenOrders;